<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide3',
  data() {
    return {
      parallax: [
        {
          start: 1000,
          end: 1300,
          fromStyle: { transform: 'translateX(1200px) rotateZ(0deg)' },
          toStyle: { transform: 'translateX(0px) rotateZ(-20deg)' },
          easing: 'linear'
        },
        {
          start: 3000,
          end: 3400,
          fromStyle: { transform: 'translateX(0px) rotateZ(-20deg) translateY(0px)' },
          toStyle: { transform: 'translateX(0px) rotateZ(-10deg) translateY(1800px)' },
          easing: 'linear'
        }
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/03_Gift.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 570px;
    height: 550px;
    left: -270px;
    top: 150px;
    transition: 0.6s;
    z-index: 2;

    @media(max-width: 600px) {
      width: 270px;
      left: -120px;
    }
    @media(max-width: 400px) {
      width: 200px;
      left: -100px;
      top: 0;
    }
}
</style>
